<template>
<m-pageframe
    title="Search RedChirp Numbers"
>
<v-container
    fluid
    style="padding-left: 15px; padding-right: 15px;"
>

    <v-row
        style="padding-left: 15px; padding-right: 15px;"
    >
    <v-text-field
        v-model="search.full_text"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
        style="margin-bottom: 15px;"
        v-on:input="doSearch"
        autocomplete="off"
     >
        <span
            slot="append-outer"
        >
            <v-menu
                bottom
                offset-y
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-icon
                        v-bind="attrs"
                        v-on="on"
                    >
                        mdi-dots-vertical
                    </v-icon>
                </template>

                <v-list>

                    <v-list-item
                        v-on:click="onClickAddOneNumberBandwidth"
                    >
                        <v-list-item-title>Bandwidth:  Add / Update one number...</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                        v-on:click="onClickAddOneNumberTwilio"
                    >
                        <v-list-item-title>Twilio:  Add / Update numbers from one sub-account...</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                        v-on:click="onClickUpdateInServiceNumbers"
                    >
                        <v-list-item-title>Update RedChirp In Service Numbers...</v-list-item-title>
                    </v-list-item>

                     <v-list-item
                        v-on:click="exportToExcel"
                    >
                        <v-list-item-title>Export to Excel...</v-list-item-title>
                    </v-list-item>


                </v-list>
            </v-menu>

        </span>

    </v-text-field>
    </v-row>

     <v-layout
        row
        wrap
        style="padding-left: 15px; padding-right: 15px;"
     >
         <v-flex flex-grow-0>
                <v-checkbox
                    label="Assigned"
                    v-model="search.include_assigned"
                    style="margin-right: 15px"
                    v-on:change="doSearch"
                />
         </v-flex>

        <v-flex flex-grow-0>
            <v-checkbox
                label="Unassigned"
                style="margin-right: 15px"
                v-model="search.include_unassigned"
                v-on:change="doSearch"
            />
        </v-flex>

        <v-flex flex-grow-0>
            <v-checkbox
                label="Local"
                style="margin-right: 15px"
                v-model="search.include_local"
                v-on:change="doSearch"
            />
        </v-flex>

        <v-flex flex-grow-0>
            <v-checkbox
                label="Toll Free"
                style="margin-right: 15px"
                v-model="search.include_toll_free"
                v-on:change="doSearch"
            />
        </v-flex>

        <v-flex flex-grow-0>
            <v-checkbox
                label="Messaging Only"
                style="margin-right: 15px"
                v-model="messaging_only"
                v-on:change="doSearch"
            />
        </v-flex>

        <v-flex flex-grow-0>
            <v-checkbox
                label="Select Multiple"
                v-model="select_multiple"
                v-on:change="changeSelectMultiple"
            />
        </v-flex>
     </v-layout>

     <v-data-table
        :headers="headers"
        :items="results"
        :items-per-page="50"
        class="elevation-1"
        :footer-props="{
            itemsPerPageOptions: [25, 50, 100, -1],
        }"
    >
        <template v-slot:item.selected="{ item }">

            <v-simple-checkbox
                :value="item.selected"
                :ripple="false"
                v-on:input='onSelectItem(item)'
            />
        </template>

        <template v-slot:item.date="{ item }">
            {{$rc.pretty(item.last_confirm_inservice_time,'date')}}
        </template>

        <template v-slot:item.time="{ item }">
            {{$rc.pretty(item.last_confirm_inservice_time,'time')}}
        </template>

         <template v-slot:item.endpoint="{ item }">
            {{$rc.pretty(item.endpoint,'endpoint')}}
        </template>

         <template v-slot:item.toll_free="{ item }">
             <span :style="itemStyle(item)">
                {{prettyPrintTollFree(item)}}
            </span>
        </template>

        <template v-slot:item.bandwidth_campaign_fully_provisioned="{ item }">
             {{prettyBandwidthCampaignFullyProvisied(item)}}
        </template>






        <template v-slot:item.expected_to_be_in_service="{ item }">
            <v-simple-checkbox
                v-model="item.expected_to_be_in_service"
                disabled
            />
        </template>

        <template v-slot:item.supports_voice="{ item }">
            <v-simple-checkbox
            v-model="item.supports_voice"
            disabled
            ></v-simple-checkbox>
        </template>

        <template v-slot:item.supports_messaging="{ item }">
            <v-simple-checkbox
            v-model="item.supports_messaging"
            disabled
            ></v-simple-checkbox>
        </template>

        <template v-slot:item.bandwidth_sms_enabled="{ item }">
            <v-simple-checkbox
            v-model="item.bandwidth_sms_enabled"
            disabled
            ></v-simple-checkbox>
        </template>




        <template v-slot:item.assignment="{ item }">
            {{prettyPrintAssignment(item)}}
        </template>

        <template v-slot:item.complimentary_endpoint="{ item }">
            <v-simple-checkbox
            v-model="item.complimentary_endpoint"
            disabled
            ></v-simple-checkbox>
        </template>

        <template v-slot:item.action="{ item }">
            <v-menu
                bottom
                offset-y
            >

                <template v-slot:activator="{ on, attrs }">
                    <v-icon
                        v-bind="attrs"
                        v-on="on"
                        style="margin-right: 24px"
                    >
                        mdi-dots-vertical-circle-outline
                    </v-icon>
                </template>

                <v-list>
                    <v-list-item
                        v-on:click="onClickSignInAs(item)"
                        :disabled="item.assigned_to_employee_id == null"
                    >
                        <v-list-item-title>Sign in as {{item.assigned_to_employee_username}}...</v-list-item-title>
                    </v-list-item>

                    <v-divider/>

                    <v-list-item
                        v-on:click="assignPhoneNumbers(item)"
                    >
                        <v-list-item-title>Assign to Organization...</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                        v-on:click="viewOrganizationSettings(item)"
                        :disabled="!hasOrganizationSettings(item)"
                    >
                        <v-list-item-title>Organization Settings...</v-list-item-title>
                    </v-list-item>

                    <v-divider/>

                    <v-list-item
                        v-on:click="unassignPhoneNumbers(item)"
                    >
                        <v-list-item-title>Remove from Organization</v-list-item-title>
                    </v-list-item>

                    <m-restricted-menu-list-item
                        v-on:click="onClickRemoveFromRedChirp(item)"
                        :disabled="!$rc.$state.hasRedChirpStaffRoleAdministrator()"
                        text="Remove from RedChirp..."
                    />


                    <v-divider/>

                    <m-restricted-menu-list-item
                        v-on:click="toggleComplimentary(item)"
                        :disabled="!$rc.$state.hasRedChirpStaffRoleFinance()"
                        text="Toggle Complimentary"
                        tooltip_text="Finance Only"
                    />

                    <m-restricted-menu-list-item
                        v-on:click="toggleActive(item)"
                        :disabled="!$rc.$state.hasRedChirpStaffRoleAdministrator()"
                        text="Toggle Active (Expected to be in Service)"
                    />

                    <v-divider/>

                    <v-list-item
                        v-on:click="placeTNOptionOrder(item)"
                        :disabled="!$rc.$state.hasRedChirpStaffRoleAdministrator()"
                    >
                        <v-list-item-title>Set Campaign Id (Place TN Options Order)</v-list-item-title>
                    </v-list-item>

                    <template v-if="item.sub_type === 'ptsn-toll-free' && item.organization_id != null">
                        <v-divider />
    
                        <v-list-item @click="onClickTollFreeVerificationInfo(item)">
                            <v-list-item-title>Toll Free Verification Information...</v-list-item-title>
                        </v-list-item>
                    </template>

                </v-list>
            </v-menu>


        </template>

     </v-data-table>

     <m-admin-assign-phone-numbers-dialog
        ref="assign-numbers-dialog"
        v-on:ok="select_multiple = false; clearSelection(); doSearch();"
    />

    <m-admin-add-one-in-service-number
        ref="add-one-number-dialog"
        v-on:update="onInService"
    />

     <m-autocomplete-organization
        :value="null"
        dialog_only
        ref="search_orgs"
        v-on:input="doUpdateNumbersFromOneTwilioSubAccount"
    />


</v-container>
</m-pageframe>
</template>

<script>
const E164 = require('@/js/E164.js');

export default {
    data() {
        return {
            search: {
                full_text: null,
                include_assigned: true,
                include_unassigned: true,
                include_local: true,
                include_toll_free: true,
            },

            messaging_only: false,

            select_multiple: false,

            results: [],
            selection: [],
        }
    },

    mounted () {
        this.doSearch();
    },

    methods: {
        doSearch()
        {
            this.updateSelections();

            let include_subtypes = [];

            if ( this.search.include_local ) include_subtypes.push('ptsn-local');
            if ( this.search.include_toll_free ) include_subtypes.push('ptsn-toll-free');

            let include_network = ['bandwidth','twilio'];

            let include_assign = [];

            if ( this.search.include_unassigned ) include_assign.push('null');

            if ( this.search.include_assigned )
            {
                include_assign.push('available');
                include_assign.push('assigned-to-employee');
                include_assign.push('assigned-to-employee-group');
                include_assign.push('assigned-to-organization-bot');
            }

            let search = {
                'full_text' : this.search.full_text,
                'sub_type' : include_subtypes,
                'network' : include_network,
                'assignment' : include_assign,
            };

            if ( this.messaging_only )
            {
                search.supports_voice = false;
                search.support_messaging = true;
            }

            this.$rc.rest({
                'spinner': true,
                'endpoint': 'LIST: /api/v1/numbers',

                'params' : search,

                'on_success': (data) => {
                        this.results = data.results;
                        this.applySelections();
                    },

                'on_error': 'Unable to search RedChirp phone numbers.',
            });
        },

        prettyPrintAssignment(result)
        {
            let dev_label = E164.getDevEndpointLabel(result.endpoint);
            if ( dev_label != null ) return dev_label;

            if ( result.assignment == 'available' ) return 'Available'
            if ( result.assignment == 'assigned-to-employee' ) return result.assigned_to_employee_label;
            if ( result.assignment == 'assigned-to-employee-group' ) return 'Team';
            if ( result.assignment == 'assigned-to-organization-bot' ) return 'Bot';
        },

        prettyPrintTollFree(result)
        {
            if ( !result.in_service_at_comm_provider ) return 'Not In Service';
            if ( result.sub_type == 'ptsn-toll-free') return 'Toll Free';
            return 'Local';
        },

        prettyPrint(endpoint)
        {
            return E164.prettyPrintUsPhoneNumber(endpoint)
        },

        updateSelections()
        {
            let items = this.results;

            for ( let i = 0; i < items.length; i++ )
            {
                this.updateSelection(items[i]);
            }
        },

        updateSelection(item)
        {
            let selected = item.selected == true;

            for ( let i = 0; i < this.selection.length; i++ )
            {
                if ( this.selection[i].endpoint == item.endpoint )
                {
                    this.selection[i].selected = selected;
                    return;
                }
            }

            this.selection.push({'endpoint' : item.endpoint, 'selected' : selected});
        },

        applySelections()
        {
           for ( let i = 0; i < this.selection.length; i++ )
           {
               this.applySelection(this.selection[i]);
           }
        },

        applySelection(selection)
        {
            for ( let i = 0; i < this.results.length; i++ )
            {
                if ( this.results[i].endpoint == selection.endpoint )
                {
                    this.results[i].selected = selection.selected;
                }
            }
        },

        prettyBandwidthCampaignFullyProvisied(item)
        {
            return (''+item.bandwidth_campaign_fully_provisioned).replace('not-applicable-', 'na-');
        },

        getSelectedEndpoints()
        {
            if ( this.select_multiple == false ) return [];

            let ret = [];

            for ( let i = 0;i < this.results.length; i++ )
            {
                if( this.results[i].selected == true )
                    ret.push(this.results[i].endpoint);
            }

            return ret;
        },

        getSelectedOrgOwnedEndpoints()
        {
            if ( this.select_multiple == false ) return [];

            let ret = [];

            for ( let i = 0;i < this.results.length; i++ )
            {
                if( this.results[i].selected == true )
                    ret.push(this.results[i]);
            }

            return ret;
        },

        assignPhoneNumbers(item)
        {
            let endpoints = this.getSelectedEndpoints();
            if ( !endpoints.includes(item.endpoint) )
                endpoints.push(item.endpoint);

            this.$refs['assign-numbers-dialog'].showDialog(endpoints, true);
        },

        toggleComplimentary(item)
        {
            let endpoints = this.getSelectedOrgOwnedEndpoints();

            if ( !this.getSelectedEndpoints().includes(item.endpoint) )
                endpoints.push(item);

            for ( let i = 0; i < endpoints.length; i++ )
            {
                let item = endpoints[i];

                let changes = {
                    'endpoint' : item.endpoint,
                    'complimentary_endpoint' : !item.complimentary_endpoint,
                };

                this.$rc.patchOrganizationEndpoint(
                    changes.endpoint,
                    changes,
                    () => { this.doSearch(); },
                    () => {},
                );
            }
        },

        toggleActive(item)
        {
            let endpoints = this.getSelectedOrgOwnedEndpoints();

            if ( !this.getSelectedEndpoints().includes(item.endpoint) )
                endpoints.push(item);

            for ( let i = 0; i < endpoints.length; i++ )
            {
                let item = endpoints[i];

                let changes = {
                    'endpoint' : item.endpoint,
                    'expected_to_be_in_service' : !item.expected_to_be_in_service,
                };

                this.$rc.patchOrganizationEndpoint(
                    changes.endpoint,
                    changes,
                    () => {
                        this.doSearch();

                        this.$rc.alert('Active state changed', 'The active state of the selected phone number(s) has been chagned.<br/><br/>Make sure that the complimentary state is set properly (i.e. should the customer be charged for this endpoint or not).');
                    },
                    () => {},
                );
            }
        },

        unassignPhoneNumbers(item)
        {
            let endpoints = this.getSelectedEndpoints();
            if ( !endpoints.includes(item.endpoint) )
                endpoints.push(item.endpoint);

            this.$refs['assign-numbers-dialog'].showDialog(endpoints, false);
        },

        onClickRemoveFromRedChirp(item)
        {
            this.$rc.confirm({
                'title': 'Remove Phone Number From RedChirp',
                'body': 'Remove this phone number form RedChirp.  This will also remove any assignments associated with this number.<br/><br/><b>NOTE:</b> If the number shows up in our Bandwidth account again it will be automatically re-added.<br/><br/>Type <b>confirm</b> to proceed.',
                'btn_text_ok': 'Remove',
                'btn_text_cancel': 'Cancel',
                'text_to_confirm': 'confirm',
                'on_ok': () => {
                    this.$rc.showSpinner();

                    this.$rc.rest(
                        'DELETE: /api/v1/comms/numbers',

                        {
                            'endpoint' : item.endpoint,
                        },

                        (data) => {
                            this.$rc.hideSpinner();

                            this.doSearch();
                        },

                        () => {
                            this.$rc.hideSpinner();
                            this.$rc.alert('Error','Unable to complete API call');
                        },
                    );
                },
            });
        },

        onSelectItem(item)
        {
            let selected = item.selected == true;
            selected = !selected;
            item.selected = selected;
            this.$forceUpdate();
        },

        changeSelectMultiple()
        {
            if ( this.select_multiple == true ) return;
            this.clearSelection();
        },

        clearSelection()
        {
            this.selected = [];
            for ( let i = 0; i < this.results.length; i++ )
            {
                this.results[i].selected = false;
            }

            this.$forceUpdate();
        },

        onClickAddOneNumberBandwidth()
        {
            this.$refs['add-one-number-dialog'].showDialog();
        },

        onClickAddOneNumberTwilio()
        {
            this.$refs['search_orgs'].showDialog();
        },

        doUpdateNumbersFromOneTwilioSubAccount(organization_id)
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'GET: /api/v1/twilio/numbers/update-from-sub-account/:organization_id',

                'params' : {
                        'organization_id': organization_id,
                    },

                'on_success': (data) => {
                        this.doSearch();
                    },

                'on_error': 'Unable to update numbers from sub account',
            });
        },

        onInService(endpoint)
        {
            this.search.full_text = endpoint.substring('E164:+1'.length);
            this.doSearch();
        },

        onClickUpdateInServiceNumbers()
        {
            this.$rc.rest(
                'GET: /comms/update-inservice-numbers',

                {
                },

                (data) => {
                    this.$rc.snackbar('Updating in service numbers.  This may take several minutes to  complete.')
                },

                () => {
                    this.$rc.alert('Error','Unable to update inservice numbers');
                },
            );
        },

        exportToExcel()
        {
            this.$rc.excelExport(
                    'GET: /api/v1/numbers/excel-export',
                    {
                    }
                );
        },

        viewOrganizationSettings(item)
        {
            this.$router.push(
                {
                    name: 'settings-organization',
                    params: {
                        'organization_id': item.organization_id,
                    }
                }
            );
        },

        hasOrganizationSettings(item)
        {
            return item.organization_id != null;
        },

        itemStyle(item)
        {
            if ( !item.in_service_at_comm_provider )
                return "color: red; font-weight: 700;";

            return '';
        },

        onClickSignInAs(item)
        {
            this.$rc.showSpinner();

             this.$rc.newSignInAs(
                {
                    'organization_id': item.organization_id,
                    'employee_id': item.assigned_to_employee_id,
                }
            );
        },

        placeTNOptionOrder(item)
        {
            this.$rc.confirm({
                'title': 'Confirm Place TN Options Order',
                'body': 'Are you sure tha tyou want to place a TN Options Order for this phone number?',
                'btn_text_ok': 'Place Order',
                'btn_text_cancel': 'Cancel',
                'on_ok': () => {
                    this.doPlaceTNOptionOrder(item)
                },
            });
        },

        doPlaceTNOptionOrder(item)
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/numbers/place-tn-options-order',

                'params' : {
                        'endpoint': item.endpoint,
                    },

                'on_success': (data) => {
                        this.$rc.alert('Result', data.message);
                    },

                'on_error': 'Unable to place TN Options Order',
            });
        },

        onClickTollFreeVerificationInfo(item)
        {
            this.$router.push({
                name: 'admin-toll-free-registration',
                params: {
                    organization_id: item.organization_id,
                    endpoint: item.endpoint,
                }
            });
        },
    },

    computed: {
        headers() {
            let ret = [];

            if ( this.select_multiple )
            {
                ret.push({ 'text' : 'Selected', 'value' : 'selected' });
            }

            ret.push({ 'text' : 'Date', 'value' : 'date' });
            ret.push({ 'text' : 'Time', 'value' : 'time' });
            ret.push({ 'text' : 'Number', 'value' : 'endpoint' });
            ret.push({ 'text' : 'Network', 'value' : 'network' });
            ret.push({ 'text' : 'Active', 'value' : 'expected_to_be_in_service' });
            ret.push({ 'text' : 'Voice', 'value' : 'supports_voice' });
            ret.push({ 'text' : 'Messaging', 'value' : 'supports_messaging' });
            ret.push({ 'text' : 'SMS Enabled', 'value' : 'bandwidth_sms_enabled' });
            ret.push({ 'text' : 'Type', 'value' : 'toll_free' });
            ret.push({ 'text' : 'Organization', 'value' : 'organization_label' });
            ret.push({ 'text' : 'Assignment', 'value' : 'assignment' });
            ret.push({ 'text' : 'Username', 'value' : 'assigned_to_employee_username' });
            ret.push({ 'text' : 'Complimentary', 'value' : 'complimentary_endpoint' });
            ret.push({ 'text' : 'Campaign Id', 'value' : 'default_tcr_campaign_id_bandwidth' });
            ret.push({ 'text' : 'Campaign Registered', 'value' : 'bandwidth_campaign_fully_provisioned' });

            ret.push({ 'text' : 'Action', 'value' : 'action', 'align' : 'right' });


            return ret;
        }
    },
}
</script>

<style lang="scss" scoped>

</style>